module.exports = __webpack_public_path__ + "static/media/lineChart2.724e10dc.svg";